import styled from 'styled-components';

export const StyledDiv = styled.div` 
  padding: 20px;
  background:#FFF;
  /* Add your styles here */
`;
